import {NavTabs} from "@/components/navTabs/NavTabs.tsx";
import {NavTabItem} from "@/components/navTabs/NavTabs.types.ts";
import styles from "./StatusTabs.module.scss";

interface StatusTabsProps {
  tabs: NavTabItem[];
  activeTab: string;
  onTabChange: (tab: string) => void;
  className?: string;
}

export const StatusTabs = ({tabs, activeTab, onTabChange, className}: StatusTabsProps) => {
  return (
    <div className={className ? `${styles.statusTabs} ${className}` : styles.statusTabs}>
      <NavTabs variant="statuspageContent" items={tabs} selectedId={activeTab} selectTab={onTabChange} />
    </div>
  );
};
